<coin-v2-dialog-frame
  [header]="$safeNavigationMigration(data?.dialogTitle) | translate"
  (closeButtonClick)="close()">
  <div class="content">
    @for (section of data?.sections; track section) {
      <div class="section-container">
        <div class="section">
          @if (section?.title) {
            <h2>{{ $safeNavigationMigration(section?.title) | translate }}</h2>
          }
          @if (section.isEditable) {
            <coin-v2-text-area
              [label]="$safeNavigationMigration(section?.label) | translate"
              [formControl]="formGroup.controls[section.id]"></coin-v2-text-area>
          } @else if (section?.text) {
            <p [innerHTML]="$safeNavigationMigration(section?.text) | translate"></p>
          }
        </div>
        @if (section !== data?.sections.at(-1)) {
          <div class="divider"></div>
        }
      </div>
    }
  </div>

  @if (!isReadOnly) {
    <coin-v2-dialog-footer>
      @if (data?.removeButtonText) {
        <coin-v2-button
          type="secondary"
          [icon]="'delete'"
          [text]="data.removeButtonText | translate"
          (click)="remove()"></coin-v2-button>
        <div class="v2-footer-spacer"></div>
      }
      <coin-v2-button
        type="secondary"
        [text]="'general.btnCancel' | translate"
        (click)="close()"></coin-v2-button>
      <coin-v2-button
        icon="save"
        type="primary"
        [disabled]="formGroup.pristine"
        [text]="'general.btnSave' | translate"
        (click)="save()"></coin-v2-button>
    </coin-v2-dialog-footer>
  }
</coin-v2-dialog-frame>
